let HandlePushEventLog = {
  methods: {
    logPushSource: function () {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      if (!(queries && queries['login-source'] && queries['login-source'] === 'push')) {
        return;
      }

      this.$store.dispatch('analytics/event', {
        event: 'autologin',
        p: {
          'event_by': 'push',
          'event_label': queries.event ?? '',
        }
      });

      delete (queries['login-source']);
      delete (queries['event']);

      this.$router.replace({ query: queries });
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.logPushSource();
    });
  },
};

export default HandlePushEventLog;
